import React from 'react';
import moment from 'moment';
import { isEmpty } from 'lodash';
import Wait4Me from '../../../components/Wait4Me';
import ConfirmationPopup from '../../../components/ConfirmationPopup';
import {
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from 'reactstrap';
import { dateFormat_DD_MM_YY, tmResources } from '../../../util/GlobalConstant';
import {
  refreshAnomalyState,
  getListOfAnalysts
} from '../../../services/tm/investigationDetail';

import style from './index.scss';

/**
 * AnomalyActionWidget
 */
class AnomalyActionWidget extends React.Component {
  /**
   * constructor
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      data: [],
      currentAnalyst: '',
      isLoading: false,
      confirmType: '',
      showConfirmationPopup: false,
      confirmMsg: ''
    };
  }

  onActionButtonClick = async () => {
    const { buttonText } = this.props;
    if (buttonText === 'ReOpen') {
      this.toggleConfirmation(
        'Are you sure you want to reopen the anomaly?',
        'anomalyReOpen'
      );
    } else {
      this.toggle();
    }
  };
  /**
   * onAnalystAssign
   * @returns {Promise<void>}
   */
  onAnalystAssign = async () => {
    if (isEmpty(this.state.currentAnalyst)) {
      return;
    }
    const { rowData } = this.props;
    const { alertDate, nextActions } = rowData;
    let typeOfAction = 'assign';
    if (nextActions && nextActions.indexOf('Reassign') !== -1) {
      typeOfAction = 'reassign';
    }
    const payload = {
      type: typeOfAction,
      alertID: rowData.alertId,
      alertDate: moment(alertDate, dateFormat_DD_MM_YY).format(
        dateFormat_DD_MM_YY
      ),
      analystName: this.state.currentAnalyst
    };
    await refreshAnomalyState(payload);
    this.props.dispatchInitialRequest();
  };
  /**
   * onChange
   * @param childUsername
   */
  onChange = (childUsername) => {
    this.setState({ currentAnalyst: childUsername });
  };

  onConfirm = async () => {
    await this.reOpenAnomaly();
  };

  onReject = () => {
    this.setState({
      showConfirmationPopup: false,
      confirmMsg: '',
      confirmType: ''
    });
  };

  /**
   * setModal
   */
  setModal = () => {
    this.setState({ modal: !this.state.modal, isLoading: true }, async () => {
      if (this.state.modal) {
        const { data } = await getListOfAnalysts();
        this.setState({ data, isLoading: false });
      }
    });
  };

  reOpenAnomaly = async () => {
    const { rowData } = this.props;
    const { alertDate } = rowData;
    const payload = {
      type: 'reopen',
      alertID: rowData.alertId,
      alertDate: moment(alertDate, dateFormat_DD_MM_YY).format(
        dateFormat_DD_MM_YY
      )
    };
    await refreshAnomalyState(payload);
    this.props.dispatchInitialRequest();
  };

  toggle = () => this.setModal(!this.state.modal);

  toggleConfirmation = (msg, confirmType) => {
    this.setState({
      showConfirmationPopup: !this.state.showConfirmationPopup,
      confirmMsg: msg,
      confirmType: confirmType
    });
    return false;
  };

  /**
   * render
   * @returns {*}
   */
  render() {
    const { className, buttonText, isDisabled } = this.props;
    const { modal, data, isLoading } = this.state;

    if (isDisabled) {
      return <div>{buttonText}</div>;
    }
    return (
      <div>
        {this.state.showConfirmationPopup && (
          <ConfirmationPopup
            confirmType={this.state.confirmType}
            onReject={this.onReject}
            content={this.state.confirmMsg}
            onAccept={this.onConfirm}
          />
        )}
        <a
          className={style.anomalyActionButton}
          onClick={this.onActionButtonClick}>
          {buttonText}
        </a>
        <Modal isOpen={modal} toggle={this.toggle} className={className}>
          <ModalHeader toggle={this.toggle}>Choose an Investigator</ModalHeader>
          <ModalBody>
            <FormGroup tag="fieldset">
              {isLoading && <Wait4Me />}
              {Array.isArray(data) &&
                data.map((analyst) => {
                  return (
                    <FormGroup check>
                      <Label check>
                        <Input
                          onChange={(e) => this.onChange(analyst.childUsername)}
                          type="radio"
                          name="radio1"
                        />
                        {analyst.childFullName}
                      </Label>
                    </FormGroup>
                  );
                })}
              {!Array.isArray(data) && <div>No Analysts available</div>}
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <a className={style.anomalyActionButton} onClick={this.toggle}>
              Cancel
            </a>
            <a
              className={style.anomalyActionButton}
              onClick={this.onAnalystAssign}>
              Assign
            </a>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

/**
 * AnomalyAction
 */
export class AnomalyAction extends React.Component {
  constructor(props) {
    super(props);
  }

  /**
   * getAnomalyAction
   * @param alertStatus
   * @param alertSourceId
   * @returns {{text: string, isDisabled: boolean}}
   */
  getAnomalyAction = (alertStatus, alertSourceId) => {
    let resourcesData = {};
    let isSuperVisor = false;
    try {
      resourcesData = JSON.parse(localStorage.getItem('persist:root'));
      const { authentication } = resourcesData || {};
      const authenticationData = JSON.parse(authentication);
      const { data: authData } = authenticationData;
      authData.map((item) => {
        const { details } = item || {};
        const { resource } = details || {};
        const { resourceCode } = resource || {};
        if (
          resourceCode === tmResources.APP_3_RESOURCE_UI_TM_ANOMALY_MANAGEMENT
        ) {
          isSuperVisor = true;
        }
      });
    } catch (e) {
      // do nothing
    }
    if (alertSourceId === '1') {
      if (alertStatus === 'Open' && isSuperVisor) {
        return {
          text: 'Assign',
          isDisabled: false
        };
      }

      if (alertStatus === 'Closed' && isSuperVisor) {
        return {
          text: 'ReOpen',
          isDisabled: false
        };
      }
      if (alertStatus === 'Assigned' && isSuperVisor) {
        return {
          text: 'ReAssign',
          isDisabled: false
        };
      }

      return {
        text: '',
        isDisabled: true
      };
    } else {
      return {
        text: '',
        isDisabled: true
      };
    }
  };

  /**
   * render
   * @returns {*}
   */
  render() {
    const { alertStatus, alertSourceId } = this.props.data;
    const { text, isDisabled } = this.getAnomalyAction(
      alertStatus,
      alertSourceId
    );
    return (
      <AnomalyActionWidget
        dispatchInitialRequest={this.props.dispatchInitialRequest}
        rowData={this.props.data}
        buttonText={text}
        isDisabled={isDisabled}
      />
    );
  }
}

AnomalyAction.propTypes = {};
